import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const quizAnswersMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/SensitiveCountry$',
    },
    response: {
      status: 200,
      body: {
        statusCode: ControllerStatus.CHECK_SUCCESS,
        controlCode: 'SensitiveCountry',
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            esgQuiz: {
              mainQuestion: 'AF',
              questions: {
                HUMAN_RIGHTS_VIOLATION_IDENTIFIED: false,
              },
            },
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EnergyPolicy$',
    },
    response: {
      status: 200,
      body: {
        statusCode: ControllerStatus.CHECK_SUCCESS,
        controlCode: 'EnergyPolicy',
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            tradeSectors: [],
            esgQuiz: {
              questions: {
                SINGLE_MULTI_SITE: 'SINGLE_SITE',
                ACTIVITY_TYPE_COVERED: 'UPSTREAM',
                UNCONVENTIONAL_PRACTICES: false,
                CONTRIBUTE_GAS_FIELD: false,
              },
              mainQuestion: 'GAS',
            },
          },
        },
      } satisfies ControllerDetails,
    },
  },
];
